import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b4ebff20&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b4ebff20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ebff20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ebff20')) {
      api.createRecord('b4ebff20', component.options)
    } else {
      api.reload('b4ebff20', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b4ebff20&scoped=true&", function () {
      api.rerender('b4ebff20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n1n1Tw2dFAm3/JS/teamMember.vue"
export default component.exports